




import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import SForm from './SForm.vue';
import { TranslateResult } from 'vue-i18n';
import { ElementValidation, ISingleElementValidationData } from './ValidationModule';

@Component
export default class SFormElement extends Vue {
  @Prop() protected value!: any; // eslint-disable-line @typescript-eslint/no-explicit-any
  @Inject({ from: 'sForm', default: undefined }) private sForm?: SForm;
  protected errorMessages: (string | TranslateResult)[] = [];

  @Prop(String) private validationPath?: string;
  @Prop(String) private validationUid?: string;
  private elementValidation?: ElementValidation;

  private created() {
    if (this.sForm && this.validationPath) {
      this.elementValidation = new ElementValidation(
        this,
        this.getAllValues,
        this.sForm.reactiveProps.validationGroup,
        this.validationPath,
        this.sForm.rules,
        this.validationUid,
      );

      this.validateWithTriggers();
    }
  }

  public destroyed() {
    if (this.elementValidation) {
      this.elementValidation.validationGroup.removeElementValidation(this.elementValidation);

      this.elementValidation.elementsToTrigger.forEach(element => {
        element.validateAndSetMessage();
      });
    }
  }

  private getAllValues(): ISingleElementValidationData {
    return {
      dataValue: this.value,
      objectValue: this.objectValue,
    };
  }

  @Watch('value')
  private validateWithTriggers(): void {
    if (!this.elementValidation) return;
    this.elementValidation.validationGroup.updateFormElemement(this.elementValidation);
    this.validateAndSetMessage();

    this.elementValidation.elementsToTrigger.forEach(element => {
      element.validateAndSetMessage();
    });
  }

  private validateAndSetMessage(): void {
    if (!this.elementValidation) return;

    this.elementValidation.validate();
    this.setErrorMessage();
  }

  @Watch('$i18n.locale')
  private setErrorMessage(): void {
    if (!this.elementValidation) return;
    this.errorMessages = this.elementValidation.errorMessages;
  }

  protected get isValid(): boolean {
    return this.elementValidation ? this.elementValidation.valid : true;
  }

  protected get hasWarning(): boolean {
    return this.elementValidation ? this.elementValidation.hasWarning : false;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  protected get objectValue(): any {
    return undefined;
  }
}
